import { render, staticRenderFns } from "./Regulamento.vue?vue&type=template&id=49169099&scoped=true&"
import script from "./Regulamento.vue?vue&type=script&lang=js&"
export * from "./Regulamento.vue?vue&type=script&lang=js&"
import style0 from "./Regulamento.vue?vue&type=style&index=0&id=49169099&lang=scss&scoped=true&"
import style1 from "./Regulamento.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49169099",
  null
  
)

export default component.exports